// extracted by mini-css-extract-plugin
module.exports = {"box":"TrialsOnBlocksInfoBanner_box__XA8q6","icon":"TrialsOnBlocksInfoBanner_icon__18H5f"};